/* 
Object:         Viewmode
Description:    This ensures that the user views a module in show or edit mode.
Used in:        Grid (kendo), Tabstrip (kendo), Module Navigation, Splitter (kendo) 
*/

import { ModuleActionViewEnum } from "./enums/moduleActionViewEnum";
import * as grid from "./grid";

// this is the local set mode for the form presented to the user.
var _viewmode = ModuleActionViewEnum.Edit;

/**
 * Get mode (edit or show)
 */
export function getViewMode(): ModuleActionViewEnum {
    return _viewmode;
}

/**
 * Set mode (edit or show)
 * @param {ModuleActionViewEnum} viewmode
 */
export function setViewMode(viewmode: ModuleActionViewEnum): void {
    _viewmode = viewmode;

    // notify serverside.
    //var data = { viewMode: _viewmode };
    //communication.syncJSON("GET", appsettings.getUrl("Navigation/SetCurrentViewMode"), data, function (responseData) {

    //});
}

/**
 * Apply the current viewmode
 * Parameter without hash
 * @param {string} htmlElementId
 */
export function applyViewMode(htmlElementId: string): void {
    if (getViewMode() == ModuleActionViewEnum.Show) {
        disableAllInputs(htmlElementId);
    }
}

/**
 * Set elements to disabled or not (show or edit mode)
 */
export function setPaneViewMode(event: kendo.ui.SplitterContentLoadEvent): void {
    if (event == undefined) return;

    // When the viewmode is set on show
    if (getViewMode() == ModuleActionViewEnum.Show) {
        disableAllInputs(event.pane.id);
    }
}

/**
 * Set elements to disabled or not (show or edit mode)
 */
export function setTabstripViewMode(event: kendo.ui.TabStripContentLoadEvent): void {
    if (event == undefined) return;

    // When the viewmode is set on show
    if (getViewMode() == ModuleActionViewEnum.Show) {
        disableAllInputs(event.contentElement.id);
    }
}

/**
 * Set elements to disabled or not (show or edit mode)
 * @param {kendo.ui.GridEvent} event
 */
export function setGridViewMode(event: kendo.ui.GridEvent): void {
    if (event == undefined) return;
    grid.saveGridOptions(event);
    // When the viewmode is set on show
    if (getViewMode() == ModuleActionViewEnum.Show) {
        for (var i = 0; i < event.sender.element.length; i++) {
            if (event.sender.element[i] != undefined) {
                disableAllInputs(event.sender.element[i].id);
            }
        }
    }
}

/**
 * Disable all elements (input)
 * @param {string} parentElementId
 */
export function disableAllInputs(parentElementId: string): void {


    // Disable all comboboxes
    $("#" + parentElementId + " .k-combobox input").each(function (e) {
        if (this.id != undefined && this.id != "") {
            var elementId = this.id;

            var kendo_ComboBox = $("#" + elementId).data("kendoComboBox");

            if (kendo_ComboBox != undefined) {
                kendo_ComboBox.enable(false);
            }
        }
    });

    // Disable all dropdownlists
    $("#" + parentElementId + " .k-dropdownlist input").each(function () {
        if (this.id != undefined && this.id != "") {
            var elementId = this.id;

            var kendo_DropDownList = $("#" + elementId).data("kendoDropDownList");

            if (kendo_DropDownList != undefined) {
                kendo_DropDownList.enable(false);
            }
        }
    });

    // Disable all textboxes
    $("#" + parentElementId + " .k-textbox input").each(function () {
        if (this.id != undefined && this.id != "") {
            var elementId = this.id;

            var kendo_TextBox = $("#" + elementId).data("kendoTextBox");

            if (kendo_TextBox != undefined) {
                kendo_TextBox.enable(false);
            }
        }
    });

    // Disable all numeric textboxes
    $("#" + parentElementId + " .k-numerictextbox input").each(function () {
        if (this.id != undefined && this.id != "") {
            var elementId = this.id;

            var kendo_NumericTextBox = $("#" + elementId).data("kendoNumericTextBox");

            if (kendo_NumericTextBox != undefined) {
                kendo_NumericTextBox.enable(false);
            }
        }
    });

    // Disable all Kendo checkboxes
    $("#" + parentElementId + " .k-checkbox").each(function () {
        if (this.id != undefined && this.id != "") {
            var elementId = this.id;

            var kendo_CheckBox = $("#" + elementId).data("kendoCheckBox");

            if (kendo_CheckBox != undefined) {
                kendo_CheckBox.enable(false);
            }
        }
    });

    // Disable all JQuery checkboxes
    $("#" + parentElementId).find('input[type=checkbox]').attr("disabled", "disabled");

    // Disable all textarea
    $("#" + parentElementId + " .k-textarea textarea").each(function () {
        if (this.id != undefined && this.id != "") {
            var elementId = this.id;

            var kendo_TextArea = $("#" + elementId).data("kendoTextArea");

            if (kendo_TextArea != undefined) {
                kendo_TextArea.enable(false);
            }
        }
    });


    // Disable all date pickers
    $("#" + parentElementId + " .k-datepicker input").each(function () {

        if ($(this).attr('id') != undefined && $(this).attr('id') != "") {
            var elementId = $(this).attr('id');

            var kendo_datepicker = $("#" + elementId).data("kendoDatePicker");

            if (kendo_datepicker != undefined) {
                kendo_datepicker.enable(false);
            }
        }
    });

    // Disable all time pickers
    $("#" + parentElementId + " .k-timepicker input").each(function () {

        if ($(this).attr('id') != undefined && $(this).attr('id') != "") {
            var elementId = $(this).attr('id');

            var kendo_datepicker = $("#" + elementId).data("kendoTimePicker");

            if (kendo_datepicker != undefined) {
                kendo_datepicker.enable(false);
            }
        }
    });

    // Disable all datetime pickers
    $("#" + parentElementId + " .k-datetimepicker input").each(function () {
        if (this.id != undefined && this.id != "") {
            var elementId = this.id;

            var kendo_datetimepicker = $("#" + elementId).data("kendoDateTimePicker");

            if (kendo_datetimepicker != undefined) {
                kendo_datetimepicker.enable(false);
            }
        }
    });

    // Disable all listbox
    $("#" + parentElementId + " .k-listbox select").each(function () {

        if ($(this).attr('id') != undefined && $(this).attr('id') != "") {
            var elementId = $(this).attr('id');

            var kendo_listbox = $("#" + elementId).data("kendoListBox");

            if (kendo_listbox != undefined) {
                kendo_listbox.enable(".k-list-item", false);
            }
        }
    });

    // Disable uploads
    $("#" + parentElementId + " .k-upload").addClass("k-disabled");

    // Disable general buttons that use the class k-button (except export buttons, (date) nav buttons)
    $("#" + parentElementId + " .k-button").not(".k-grid-excel, .k-grid-pdf, .k-nav-today, .k-nav-prev, .k-nav-next").attr("disabled", "disabled");

    // Disable all buttons (except cancel, export and (date) nav buttons)
    $("#" + parentElementId + " button").not("[id*=cancelForm]").not(".k-grid-excel, .k-grid-pdf, .k-nav-today, .k-nav-prev, .k-nav-next").attr("disabled", "disabled");

    // Show button in grid should be available
    $("#" + parentElementId + " .k-grid-show_command").removeAttr("disabled");

    // File select button
    $("#" + parentElementId + " .k-button").find("[type=file]").attr("disabled", "disabled");

}
